import { PageMeta } from '@/@vxapp/@Enums/PageMeta'

export default [
  { heading: 'eCommerce' },
  {
    page: PageMeta.Orders.List,
    title: 'Orders',
    icon: { icon: PageMeta.Orders.List.Icon },
    to: PageMeta.Orders.List.Name,
  },
  {
    title: 'Products',
    page: PageMeta.Products.List,
    icon: { icon: PageMeta.Products.List.Icon },
    children: [
      {
        page: PageMeta.Products.List,
        title: 'All Products',
        icon: { icon: PageMeta.Products.List.Icon },
        to: PageMeta.Products.List.Name,
      },
      {
        page: PageMeta.Categories.List,
        title: 'Categories',
        icon: { icon: PageMeta.Categories.List.Icon },
        to: PageMeta.Categories.List.Name,
      },
      {
        title: 'Booking Options',
        page: PageMeta.BookingOptions.List,
        children: [
          {
            page: PageMeta.BookingOptions.List,
            title: 'All Booking Options',
            icon: { icon: PageMeta.BookingOptions.List.Icon },
            to: PageMeta.BookingOptions.List.Name,
          },
          {
            page: PageMeta.Selections.List,
            title: 'Selections',
            icon: { icon: PageMeta.Selections.List.Icon },
            to: PageMeta.Selections.List.Name,
          },
        ],
      },
    ],
  },
]
